// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2uJ4E","backdrop":"styles_backdrop__MaMK-","ellipsis":"styles_ellipsis__dpPvq"};